import { render, staticRenderFns } from "./paperStatisyics.vue?vue&type=template&id=481229a6&scoped=true&"
import script from "./paperStatisyics.vue?vue&type=script&lang=js&"
export * from "./paperStatisyics.vue?vue&type=script&lang=js&"
import style0 from "./paperStatisyics.vue?vue&type=style&index=0&id=481229a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481229a6",
  null
  
)

export default component.exports